// extracted by mini-css-extract-plugin
export default {"tabControl":"NavTabControl_tabControl__eK79a","tabItems":"NavTabControl_tabItems__3oxcW","tabLink":"NavTabControl_tabLink__lhYHg","tabHighlight":"NavTabControl_tabHighlight__hlzxU"};